module.exports = __webpack_public_path__ + "static/media/food-pattern-dark.563b7306.png";